import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import imageProxy from '@/js/common/Domain/Service/imageProxy';

import directionsTemplate from './template.html';

@propsDecorator({
    el: '<li></li>',
    bindings: {
        '.js-city-preview': 'attr: { href: link }',
        '.js-city-preview-price-value': 'text: formatedPrice',
        '.js-city-preview-price': 'fade: formatedPrice',
    },
    events: {
        'click .js-city-preview': 'directionClick',
    },
    computeds: {
        formatedPrice: {
            deps: ['price'],
            get(price) {
                if (!price) {
                   return 0;
                }

                return price.formatNumber();
            },
        },
    },
    bindingHandlers: {
        fade: {
            set($element, value) {
                if (value) {
                    $element.fadeIn();
                    return;
                }

                $element.fadeOut();
            },
        },
    },
})
export default class DirectionsView extends Backbone.Epoxy.View {
    directionClick(e) {
        e.preventDefault();
        const $link = $(e.currentTarget);
        window.location = $link.attr('href');
        return false;
    }

    initialize(options) {
        this.collectionView = options.collectionView;
        const jsonData = this.model.toJSON({ computeds: true });

        const selectedDirectionsTemplate = options?.collectionView?.directionsTemplate
            ? options.collectionView.directionsTemplate
            : directionsTemplate;

        const direction = selectedDirectionsTemplate({
            ...jsonData,
            imageProxy,
        });

        this.$el.html(direction);
    }
}
